import { GatewayTransactionType } from '@pillar-portal/api-types';
import { TransactionsListContent } from '@/app/payment-transactions/TransactionsListContent';

export function CardVaultContent() {
    return (
        <TransactionsListContent
            pageTitle="Card Vault"
            loadingLabel="Loading card vault transactions..."
            endOfListLabel="End of card vault transactions."
            amountColumnVisible={false}
            detailBasePath="/card-vault"
            gatewayTransactionTypes={[GatewayTransactionType.CARD_TOKEN]}
        />
    );
}
